<template>
	<ListDetailLayout
			placeholder-value="Search for device revisions..."
			:store="deviceRevisionsStore"
      index-route-name="admin.devices.revisions"
			create-permissions="create:device-revisions"
			@on-create="$router.push({ name: 'admin.devices.revisions.revision', params: { revision: 'NEW' } })"
			@on-paginate="(page) => useOnPaginate(page, refreshDeviceRevisions, params)"
			@on-search="(page) => useOnSearch(page, refreshDeviceRevisions, params)"
      :filter="params.filter"
      @on-filter="({ filter }) => useOnFilter(filter, refreshDeviceRevisions, params)"
	  	create-button-admin-page="create-device-revision-admin-btn"
	    search-admin-page="search-device-revision-admin-page"
	>

		<template #list>
			<li v-for="revision in deviceRevisionsStore.getDeviceRevisions" :key="revision.id">
				<router-link :to="{ name: 'admin.devices.revisions.revision', params: { revision: revision.id } }" v-slot="{isActive}">
					<div :class="[isActive ? 'border-primary-500 dark:bg-surface-600' : 'border-transparent hover:bg-surface-50 dark:hover:bg-surface-800', 'transition-colors border-l-4 flex items-center justify-between gap-x-6 py-5 pl-3 pr-4 bg-surface-0 dark:bg-surface-800']">

						<div class="min-w-0">
							<div class="flex items-start gap-x-3 truncate">
								<p class="text-sm font-semibold leading-6 text-surface-900 dark:text-surface-200">{{ revision.name }}</p>
							</div>

							<div class="mt-1 flex items-center gap-x-2 text-xs leading-5 text-surface-500 dark:text-surface-400 truncate">
								<p class="whitespace-nowrap">
									{{ revision.device_model?.name ?? $t('common.na') }}
								</p>
							</div>
						</div>

					</div>
				</router-link>
			</li>
		</template>

		<template #detail>
				<router-view v-if="$route.params.revision" @on-save="refreshDeviceRevisions" @on-delete="refreshDeviceRevisions"></router-view>
		</template>

	</ListDetailLayout>
</template>

<script>
import ListDetailLayout from "@/Layouts/ListDetailLayout.vue";
import Container from "@/Components/Container.vue";
import { mapStores } from "pinia";
import {useDeviceRevisionsStore} from "@/stores/deviceRevisions.js";
import {useOnFilter, useOnPaginate, useOnSearch} from "@/Composables/Pagination.js";

export default {
	name: "DeviceRevisionsIndex",
	data() {
		return {
			params: {
				include: ['deviceModel'],
        filter: {
          device_manufacturer_ids: [],
          device_type_ids: [],
          device_model_ids: [],
          regulation_ids: [],
          vehicle_manufacturer_ids: [],
        }
			}
		}
	},
	methods: {
    useOnFilter,
		useOnSearch,
		useOnPaginate,
		refreshDeviceRevisions(){
			return this.deviceRevisionsStore.indexDeviceRevisions(this.params)
		}
	},
	components: {Container, ListDetailLayout},
	computed: {
		...mapStores(useDeviceRevisionsStore)
	},
	async mounted() {
		await this.refreshDeviceRevisions();
	}
}
</script>
